/**
 * Yes, I checked and this doesn't pose a security risk
 * @see https://www.rfc-editor.org/rfc/rfc6749#section-2.2*/
export const GOOGLE_CLIENT_ID = '771040104570-u83d8j74sqodf1od5da01ufgnhicclv3.apps.googleusercontent.com';